<script>
    import { alert } from "../store";
    import {
        DataTable,
        Toolbar,
        ToolbarContent,
        OverflowMenu,
        OverflowMenuItem,
        Button,
        Modal,
        Form,
        FormGroup,
        TextInput,
        ToolbarBatchActions,
    } from "carbon-components-svelte";
    import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
    import DocumentAdd20 from "carbon-icons-svelte/lib/DocumentAdd20";
    import {topics, Topicsvc} from "../services/topic";

    let topicsvc = new Topicsvc();
    let selectedRowIds = [];
    let confirmDelete = false;
    let opentopicmodal = false;
    let newTopicName = "New topic";
    let updateTopicId;    

    
    function remove() {
        try {
            let toBeDeleted = [];
            selectedRowIds.forEach((item) => {
                for (var i = 0; i < $topics.length; i++) {
                    if ($topics[i].id == item) {
                        $topics[i].active = false;
                        toBeDeleted.push($topics[i])
                        console.log("deleteTopic: " + $topics[i]);
                    }
                }
            });
            topicsvc.update(toBeDeleted);
        } catch (e) {
            //alert(e.message);
            console.log("Error removing topic");
            console.log(e);
            alert.update((n) => [...n, "Failed to remove topic " + e.message]);
            confirmDelete = false;
        }
        selectedRowIds = [];
        confirmDelete = false;
    }
    function createTopic() {
        const data = {
            name: newTopicName,
            active: true
        }
        try {
            topicsvc.add(data);
            console.log("Added topic " + data.name);
        } catch (e) {
            //alert(e.message);
            console.log(e);
            alert.update((n) => [
                ...n,
                "Failed to add topic " +
                    data.name +
                    " to topic " +
                    e.message,
            ]);
        }
        console.log("createTopic: reset");
        newTopicName = "";
        opentopicmodal = false;

}

</script>

<DataTable
    sortable
    selectable bind:selectedRowIds
    title="Topics"
    description="Overview of active topics:"
    headers={[
        { key: 'name', value: 'Name' }, 
        { key: 'description', value: 'Description' },
        { key: 'overflow', empty: true},
    ]}
    id="TopicsTable"
    rows={$topics}
>
    <Toolbar>
        <ToolbarBatchActions>
            <Button icon={TrashCan16} on:click={() => (confirmDelete = true)}
                >Delete</Button
            >
        </ToolbarBatchActions>
        <ToolbarContent>
            <Button
                icon={DocumentAdd20}
                aria-label="Create Topic"
                on:click={() => (opentopicmodal = true)}>Add Topic</Button
            >
        </ToolbarContent>
    </Toolbar>
    <svelte:fragment slot="cell" let:cell let:row>
        {#if cell.key === "overflow"}
            <OverflowMenu flipped>
                <OverflowMenuItem 
                    text="Edit" 
                    id="edit"
                    on:click={() => {
                        updateTopicId = row.id;
                        newTopicName = row.name;
                        opentopicmodal = true;
                    }}
                />
                <OverflowMenuItem
                    danger
                    id="delete"
                    text="Delete"
                    on:click={() => {
                        selectedRowIds.push(row.id);
                        confirmDelete = true;
                    }}
                />
            </OverflowMenu>
        {:else}{cell.value}{/if}
    </svelte:fragment>
</DataTable>

<Modal
    bind:open={confirmDelete}
    modalHeading="Delete Topic"
    primaryButtonText="Confirm"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (confirmDelete = false)}
    on:open
    on:close
    on:submit={remove}
>
    <p>Delete these topic(s).</p>
    <ul>
        {#each $topics as row}
            {#each selectedRowIds as x}
                    {#if row.id == x}
                        <li>{row.name}</li>
                    {/if}
            {/each}
        {/each}
    </ul>
</Modal>

<Modal
    bind:open={opentopicmodal}
    modalHeading="Add Topic"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (opentopicmodal = false)}
    on:open
    on:close
    on:submit={createTopic}
>
    <Form on:submit>
        <FormGroup legendText="Add a topic">
            <TextInput
                id="topicInput"
                labelText="Topic"
                bind:value={newTopicName}
            />
        </FormGroup>
    </Form>
</Modal>
